import { Itsme } from '@frontend/icons';
import { FormattedMessage } from 'react-intl';

import { DefaultContainer } from '../../../../modal/detail-modal/default-container/default-container';
import { useItsmeCard } from './itsme-card.controller';

export interface ItsmeCardProps {
    entity_id: string;
}

export const ItsmeCard = (props: ItsmeCardProps) => {
    const viewProps = useItsmeCard(props);

    if (viewProps.isLoading || !viewProps.itsme) {
        return null;
    }

    return (
        <DefaultContainer
            content={
                <div className='inline-flex flex-col items-start justify-start gap-4 self-stretch'>
                    <div
                        role='img'
                        aria-label='itsme'>
                        <Itsme className='size-10' />
                    </div>
                    <div className='text-foreground-default justify-start text-base font-medium'>
                        <FormattedMessage
                            id='platform.user.modal.security.itsme-card.description'
                            description='Description on the itsme identification card in the user security and sign-in tab'
                            defaultMessage='This user can sign in with itsme.'
                        />
                    </div>
                </div>
            }
        />
    );
};
